import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OrdenMedicaModalComponent } from '../orden-medica-modal/orden-medica-modal.component';
import { UserEntreUserService } from '@services/shared/user-entre-user.service';
import { AuthService } from '@services/auth/auth.service';
import { SignoSedeService } from '@services/entidades/signo-sedes.service';
import { SignoSede } from '@interfaces/interface-bakend/entidades/signo-sede.interface';

@Component({
    selector: 'app-botones-rapidos',
    templateUrl: './botones-rapidos.component.html',
    styleUrls: ['./botones-rapidos.component.scss'],
})
export class BotonesRapidosComponent implements OnInit {
    // Banner con Info
    showBanner: boolean = false;

    showOverlay: boolean = false;

    usuario: any = {}; // luego lo llenás con tu usuario real

    titular: any;
    grupoFamiliar: any[] = [];
    showRosarioGuardia: boolean = false;
    cargandoRosario: boolean = true;

    constructor(
        private dialog: MatDialog,
        private authService: AuthService,
        private userEntreUserService: UserEntreUserService,
        private signoSedeService: SignoSedeService,
        private cdr: ChangeDetectorRef,
    ) {}

    async ngOnInit(): Promise<void> {
        // En paralelo: el botón ya no espera a que bajen todas las sedes.
        await Promise.all([
            this.cargarFamiliares(),
            this.validarSedeRosario(),
        ]);
    }

    async cargarFamiliares(): Promise<void> {
        // 1️⃣ Titular logueado
        this.titular = await this.authService.getUserLogon();
        if (!this.titular?._id) return;

        // 2️⃣ Familiares a cargo
        const beneficiarios = await this.userEntreUserService.findGrupoFamiliar(
            this.titular._id,
        );

        this.grupoFamiliar = (beneficiarios || [])
            .filter((b) => b.adicional)
            .map((b) => ({
                _id: b.adicional._id,
                nombre: b.adicional.nombrePersona,
                apellido: b.adicional.apellidoPersona,
                identificacion: b.adicional.identificacion,
                parentesco: b.parentesco,
            }));
    }

    async validarSedeRosario(): Promise<void> {
        try {
            this.showRosarioGuardia = await this.signoSedeService.isRosarioGuardia();
        } catch (error) {
            // Fallback mientras el endpoint /signo-sedes/isRosarioGuardia no
            // esté deployado: se resuelve localmente con las sedes del usuario.
            console.error('[RosarioGuardia] Fallback local:', error);
            this.showRosarioGuardia = await this.calcularRosarioGuardiaLocal();
        } finally {
            this.cargandoRosario = false;
            this.cdr.detectChanges();
        }
    }

    /**
     * Regla de Rosario Guardia resuelta en el front (sede con codigoGecro 080).
     * Solo se usa como fallback si el endpoint del backend no responde.
     */
    private async calcularRosarioGuardiaLocal(): Promise<boolean> {
        const titular: any = await this.authService.getUserLogon();
        const signoSedes: string[] = titular?.signoSedes || [];

        if (!signoSedes.length) {
            return false;
        }

        const todasLasSedes: SignoSede[] = await this.signoSedeService.getSedes();
        const regexCodigo = /\b080\b/;

        return todasLasSedes.some(
            (sede) =>
                signoSedes.includes(sede._id!) &&
                regexCodigo.test(sede.codigoGecro || ''),
        );
    }

    openOrdenMedica(): void {
        this.dialog.open(OrdenMedicaModalComponent, {
            width: '600px',
            maxWidth: '95vw',
            panelClass: 'orden-medica-dialog',
            data: {
                titular: this.titular,
                grupoFamiliar: this.grupoFamiliar,
            },
        });
    }

    // openOrdenMedica(): void {
    //     this.dialog.open(OrdenMedicaModalComponent, {
    //         width: '600px',
    //         maxWidth: '95vw',
    //         panelClass: 'orden-medica-dialog',
    //         data: { usuario: this.usuario },
    //     });
    // }

    openOverlay(): void {
        this.showOverlay = true;
    }

    closeOverlay(): void {
        this.showOverlay = false;
    }

    redirectToApp(): void {
        window.location.href =
            'https://play.google.com/store/apps/details?id=io.cipbyte.signomedico&pcampaignid=web_share';
    }

    hideBanner(): void {
        this.showBanner = false;
    }
}
